import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { Title } from '@angular/platform-browser';
import { AppService } from '../../app.service';
import { TranslateService } from '../../translate';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { SetupUndercarriageService } from './setup-undercarriage.service';
import { CommonModule } from '@angular/common';
import {
    GlobalLabels, CurrentSelection, SelectionLists,
    Customer, JobSite, Equipment, UCSystem,
    SystemType, Side
} from '../../entities';
@Component({
    selector: 'setup-undercarriage',
    templateUrl: './setup-undercarriage.component.html',
    styleUrls: ['./setup-undercarriage.component.scss']
})
export class SetupUndercarriageComponent {
    _loading: number = 0;
    selectionSubscription: Subscription;
    translateSubscription: Subscription;
    userLanguage: string = "english";
    _currentSelection: CurrentSelection = new CurrentSelection();
    routeSubscription: Subscription;
    _leftChain: UCSystem = new UCSystem();
    _leftFrame: UCSystem = new UCSystem();
    _rightChain: UCSystem = new UCSystem();
    _rightFrame: UCSystem = new UCSystem();


    constructor(private _setupService: SetupUndercarriageService, private _appService: AppService, private titleService: Title,
        private _router: Router, private ref: ChangeDetectorRef,
        private _translate: TranslateService) {
        this.selectionSubscription = this._appService.getSelection().subscribe(message => { this.selectionChangedDetected(message); });
        this.routeSubscription = this._appService.getRouteMessage().subscribe(message => setTimeout(() => { this.selectionChangedDetected(this._appService.getLastSelection()); }, 10));
    }
    ngOnInit() {
        this.translateSubscription = this._translate._getPrefLang().subscribe(lang => setTimeout(() => { this.updateUserLang(lang); }, 2))
    }
    ngOnDestroy() {
        // unsubscribe to ensure no memory leaks
        this.selectionSubscription.unsubscribe();
        this.translateSubscription.unsubscribe();
        this.routeSubscription.unsubscribe();
    }

    updateUserLang(lang: string) {
        this.userLanguage = lang;
        this.ref.detectChanges();
    }

    Translate(value: string): string {
        return this._translate.translateToLang(value, this.userLanguage);
    }

    selectionChangedDetected(current: CurrentSelection) {
        this._currentSelection = current;
        this._selectedEquipmentChanged();
        this._selectedJobSiteChanged();
        this.ref.detectChanges();
    }

    CheckStatus(pageId: number, level: number): boolean {
        return this._appService.showMeOrNot(pageId, level);
    }

    go(dest: string): void {
        this._router.navigate([dest]);
    }

    private _selectedEquipmentChanged(): void {
        this._loading++;
        this._setupService.GetEquipmentSystems(this._currentSelection.equipment.Id).subscribe(result => {
            this._currentSelection.equipment.Systems = [];
            this._currentSelection.equipment.Systems.push(...result);
            this._leftChain = this.getSystem(Side.Left, SystemType.Chain);
            this._leftFrame = this.getSystem(Side.Left, SystemType.Frame);
            this._rightChain = this.getSystem(Side.Right, SystemType.Chain);
            this._rightFrame = this.getSystem(Side.Right, SystemType.Frame);
            this._loading--;
        });

        this._loading++;
        this._setupService.GetEquipmentMakeModelFamily(this._currentSelection.equipment.Id).subscribe(result => {
            this._loading--;
            this._currentSelection.equipment.Make = result.Make;
            this._currentSelection.equipment.Model = result.Model;
            this._currentSelection.equipment.Family = result.Family;
        }     
        );

    }

    private _selectedJobSiteChanged(): void {
        this._loading++;
        this._setupService.GetJobSiteSystems(this._currentSelection.jobSite.Id).subscribe(result => {
            this._currentSelection.jobSite.Systems = [];
            this._currentSelection.jobSite.Systems.push(...result);
            this._loading--;
        });
    }

    private getSystem(_side: Side, _type: SystemType): UCSystem {
        let k = this._currentSelection.equipment.Systems.find(m => m.Side.valueOf() == _side.valueOf() && m.SystemType.valueOf() == _type.valueOf());
        if (k) {
            console.log(_side, _type, k);
            return k;
        }
        return new UCSystem();
    }
}
